"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyFooter = void 0;
const react_1 = __importDefault(require("react"));
function StickyFooter({ testId, children, }) {
    return (react_1.default.createElement("div", { className: "fixed bottom-0 border-t border-borderColor w-full py-4 bg-defaultBg z-30", "data-testid": testId },
        react_1.default.createElement("div", { className: "flex flex-col justify-center mx-4 sm:mx-0 sm:flex-row" }, children)));
}
exports.StickyFooter = StickyFooter;
//# sourceMappingURL=StickyFooter.js.map